import React, { useEffect, useState } from "react";
import { Table } from "antd";
import type { TableColumnsType } from "antd";
import { TCallOpenData } from "../../../../types";
import DashboardCardComponent from "../../../../components/actionCard/dashboardCard";

type TProps = {
  dailyTicketCount: TCallOpenData;
  isDailyTicketLoading: boolean;
};

const CurrentDayTickets: React.FC<TProps> = ({
  dailyTicketCount,
  isDailyTicketLoading,
}) => {
  const columns: TableColumnsType<any> = [
    {
      title: (
        <>
          <span style={{ paddingLeft: "10px", fontSize: 12 }}>
            Open Ticket Info
          </span>
        </>
      ),
      dataIndex: "parameter",
      key: "parameter",
      fixed: "left",
      width: 250,
      className: "font-medium cell-bordered row-bordered",
    },
    {
      // title: "Today",
      children: [
        {
          title: () => (
            <span style={{ color: "#07776C", fontSize: 12 }}>Service</span>
          ),
          dataIndex: "service", // change to "service"
          key: "service", // change to "service"
          align: "center",
        },
        {
          title: () => (
            <span style={{ color: "#07776C", fontSize: 12 }}>Install</span>
          ),
          dataIndex: "install", // change to "install"
          key: "install", // change to "install"
          align: "center",
        },
        {
          title: () => (
            <span style={{ color: "#07776C", fontSize: 12 }}>Others</span>
          ),
          dataIndex: "other", // change to "other"
          key: "other", // change to "other"
          align: "center",
          className: "cell-bordered",
        },
      ],
    },
  ];

  return (
    <>
      <DashboardCardComponent
        cardTitle={"Total Open Tickets"}
        service={dailyTicketCount.callOpenTotal.serviceCount}
        install={dailyTicketCount.callOpenTotal.installCount}
        other={dailyTicketCount.callOpenTotal.othersCount}
      />
      <Table
        // style={{ height: }}
        loading={isDailyTicketLoading}
        columns={columns}
        dataSource={
          dailyTicketCount
            ? [
                {
                  key: "1",
                  parameter: "Attended / Scheduled",
                  service: dailyTicketCount.callOpenAttended.serviceCount,
                  install: dailyTicketCount.callOpenAttended.installCount,
                  other: dailyTicketCount.callOpenAttended.othersCount,
                },
                {
                  key: "2",
                  parameter: "Dealer Dependent",
                  service:
                    dailyTicketCount.callOpenDealerDependency.serviceCount,
                  install:
                    dailyTicketCount.callOpenDealerDependency.installCount,
                  other: dailyTicketCount.callOpenDealerDependency.othersCount,
                },
                {
                  key: "3",
                  parameter: "Hold Spares",
                  service: dailyTicketCount.callOpenHoldSpares.serviceCount,
                  install: dailyTicketCount.callOpenHoldSpares.installCount,
                  other: dailyTicketCount.callOpenHoldSpares.othersCount,
                },
                {
                  key: "4",
                  parameter: "Hold Pending Approvals",
                  service:
                    dailyTicketCount.callOpenHoldAMCApproval.serviceCount,
                  install:
                    dailyTicketCount.callOpenHoldAMCApproval.installCount,
                  other: dailyTicketCount.callOpenHoldAMCApproval.othersCount,
                },
                {
                  key: "7",
                  parameter: "Unattended / Pending",
                  service:
                    dailyTicketCount.callOpenPendingUnattended.serviceCount,
                  install:
                    dailyTicketCount.callOpenPendingUnattended.installCount,
                  other: dailyTicketCount.callOpenPendingUnattended.othersCount,
                },
                {
                  key: "5",
                  parameter: "With in TAT",
                  service: dailyTicketCount.callOpenWithinTAT.serviceCount,
                  install: dailyTicketCount.callOpenWithinTAT.installCount,
                  other: "-",
                },
                {
                  key: "6",
                  parameter: "Out of TAT",
                  service: dailyTicketCount.callOpenOutOfTAT.serviceCount,
                  install: dailyTicketCount.callOpenOutOfTAT.installCount,
                  other: "-",
                },
              ]
            : [] // In case data is not available, provide an empty array
        }
        size="large"
        pagination={false}
        scroll={{ x: "max-content" }}
        // bordered
        // rowClassName={(record, index) => (index % 1 === 0 ? "green-row" : "")} // Add class to alternate rows
      />
    </>
  );
};

export default CurrentDayTickets;
